import { Routes, Route } from 'react-router';
import Layout from './components/layout/Layout';
import Landing from './pages/Landing';
import Play from './pages/Play';
import Leaderboard from './pages/Leaderboard';
import Profile from './pages/Profile';
import Rules from './pages/Rules';
import Finals from './pages/Finals';
import Replay from './pages/Replay';
import Transparency from './pages/Transparency';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Landing />} />
        <Route path="play" element={<Play />} />
        <Route path="leaderboard" element={<Leaderboard />} />
        <Route path="profile/:wallet" element={<Profile />} />
        <Route path="rules" element={<Rules />} />
        <Route path="finals" element={<Finals />} />
        <Route path="replay/:sessionId" element={<Replay />} />
        <Route path="transparency" element={<Transparency />} />
      </Route>
    </Routes>
  );
}
